"use client";
import style from "./style.module.scss";
import JumpLink from "@/components/JumpLink";

export default function Module({ moduleData }: { moduleData: any }) {
  const { imageUrl, imageWidth, imageHeight } = moduleData?.dataBatch?.SetImg[0]?.pic ?? {};
  const jumpParams = moduleData?.dataBatch?.SetImg[0]?.skipUrl;
  console.log("---- cjy ---- ", jumpParams);
  return (
    <JumpLink jumpParams={jumpParams}>
      <div className={style["uk-pc-image"]}>{imageUrl && <img width={imageWidth} height={imageHeight} src={imageUrl} alt="" />}</div>
    </JumpLink>
  );
}
